import { NgModule, ModuleWithProviders } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  TOKEN_DATA_GETTER,
  API_LOGIN_ENDPOINT,
  API_LOGOUT_ENDPOINT,
  API_REFRESH_ENDPOINT,
  COOKIE_DOMAIN
} from './auth.constant';
import { authFeature } from './auth.state';
import { AuthEffect } from './auth.effect';
import { AuthModuleConfig } from './auth.model';
import { authTokenInterceptorProvider } from './auth-token.interceptor';

@NgModule({
  imports: [
    StoreModule.forFeature(authFeature),
    EffectsModule.forFeature([ AuthEffect ])
  ]
})
export class ZefAuthRootModule {

}

export function defaultTokenGetter(response: any) {
  return response.auth;
}

@NgModule({})
export class ZefAuthModule {
  static forRoot(config?: AuthModuleConfig): ModuleWithProviders<ZefAuthRootModule> {
    return {
      ngModule: ZefAuthRootModule,
      providers: [
        {
          provide: TOKEN_DATA_GETTER,
          useValue: config && config.tokenDataGetter
            ? config.tokenDataGetter
            : defaultTokenGetter
        },
        {
          provide: API_LOGIN_ENDPOINT,
          useValue: config && config.loginEndpoint
            ? config.loginEndpoint
            : ''
        },
        {
          provide: API_LOGOUT_ENDPOINT,
          useValue: config && config.logoutEndpoint
            ? config.logoutEndpoint
            : ''
        },
        {
          provide: API_REFRESH_ENDPOINT,
          useValue: config && config.refreshEndpoint
            ? config.refreshEndpoint
            : ''
        },
        {
          provide: COOKIE_DOMAIN,
          useValue: config?.cookieDomain ?? ''
        },
        authTokenInterceptorProvider
      ]
    };
  }
}
